import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@app/hooks';
import { selectOrderPromocodeError } from '@modules/order';

enum PROMOCODE_ERROR_SERVER_MESSAGES {
    LESS_DISCOUNT = 'This promocode has less discount, than already applied to current order',
    USED_PROMO_CODE = 'This promo code has already been used.',
}

export function usePromoCodeErrorMessage() {
    const { t } = useTranslation();
    const { code: errorCode, message: errorMessage } = useAppSelector(selectOrderPromocodeError);

    if (!errorCode) return undefined;

    if (errorCode === 404) return t('errors.promoCodeIsInvalid', 'Entered promo code is invalid');

    if (errorCode === 422) {
        if (errorMessage === PROMOCODE_ERROR_SERVER_MESSAGES.LESS_DISCOUNT)
            return t('errors.haveBiggerDiscount', 'You already have a bigger discount applied');
        if (errorMessage === PROMOCODE_ERROR_SERVER_MESSAGES.USED_PROMO_CODE)
            return t('errors.usedPromoCode', 'This promo code has already been used');
    }

    return errorMessage;
}
